module.exports = __webpack_public_path__ + "static/media/react-logo.3fbb7f63.png";